// src/components/PortalDropdown.js
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const PortalDropdown = ({ children, anchorRef, onClose }) => {
  const dropdownRef = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        anchorRef.current &&
        !anchorRef.current.contains(event.target)
      ) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose, anchorRef]);

  // Get anchor position
  const rect = anchorRef.current?.getBoundingClientRect();
  const style = rect
    ? {
        position: 'fixed',
        top: rect.bottom + 4,
        left: rect.right - 140, // adjust width as needed
        zIndex: 9999,
      }
    : { display: 'none' };

  return createPortal(
    <div ref={dropdownRef} style={style}>
      {children}
    </div>,
    document.body
  );
};

export default PortalDropdown;